import React from 'react';
import SignupBox from 'src/modules/shared/modal/components/signup';
import Modal from 'src/modules/shared/modal/components/modal';
import i18n from 'i18next';

const SecondPageSignupModal = () => {
  const mobileFeatureList = [
    i18n.t('Access all content'),
    i18n.t('For free, forever'),
  ];

  const desktopFeatureList = [
    i18n.t('Access all content'),
    i18n.t('Ask questions, get answers'),
    i18n.t('Take a health needs quiz'),
    i18n.t('Connect with others who understand'),
    i18n.t('For free, forever'),
  ];

  return (
    <Modal
      noClose={true}
      size="signup"
      textCentered={true}
    >
      <SignupBox
        group={{}}
        mobileSubtitle={
          <div>
            {mobileFeatureList.map((x, i) => (
              <div key={`m-feature-${i}`}>
                <span className="icon icon-tick-2 signup-box__text--success" /> {x}
              </div>
            ))}
          </div>
        }
        subtitle={
          <div>
            {desktopFeatureList.map((x, i) => (
              <div key={`d-feature-${i}`}>
                <span className="icon icon-tick-2 signup-box__text--success" /> {x}
              </div>
            ))}
          </div>
        }
        title={i18n.t('Join to continue')}
      />
    </Modal>
  );
};

export default SecondPageSignupModal;



// WEBPACK FOOTER //
// ./src/modules/shared/modal/components/secondPageSignupModal.js